import { render, staticRenderFns } from "./ZonaEconomica.vue?vue&type=template&id=ba41de96&scoped=true"
import script from "./ZonaEconomica.vue?vue&type=script&lang=js"
export * from "./ZonaEconomica.vue?vue&type=script&lang=js"
import style0 from "./ZonaEconomica.vue?vue&type=style&index=0&id=ba41de96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba41de96",
  null
  
)

export default component.exports